<div [class.hidden]="!show" class="float-right sticky-top alert alert-dismissible fade show" [ngClass]="[toastType]" role="alert">
    <strong>{{message}}</strong> 
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>